import { TopBias } from "@/app/@types";

export const getInsight = (topBias: TopBias) => {
    if (topBias === "Anchoring Bias")
      return "You resist numerical manipulation like a pro!";
    if (topBias === "Loss Aversion")
      return "You make decisions without fear of loss!";
    if (topBias === "Confirmation Bias")
      return "You see through your own biases!";
    return "You think like a Nobel laureate!";
  };